var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSave = function SvgSave(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 20 20"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M14.629 1.667H3.518a1.85 1.85 0 0 0-1.852 1.851v12.963c0 1.019.824 1.852 1.852 1.852H16.48a1.857 1.857 0 0 0 1.852-1.852V5.371zM9.999 16.48a2.774 2.774 0 0 1-2.777-2.778 2.774 2.774 0 0 1 2.777-2.777 2.774 2.774 0 0 1 2.778 2.778A2.774 2.774 0 0 1 10 16.48m2.778-9.259h-9.26V3.518h9.26z"
  })));
};
export default SvgSave;